import classes from './PointItem.module.sass'
import { CargoItemInterface, PointItemInterface } from '../../../../../types/interfaces'
import close from '../../../../../../assets/images/icons/close.svg'
import arrow_left from '../../../../../../assets/images/icons/arrow_left.svg'
import arrow_right from '../../../../../../assets/images/icons/arrow_right.svg'
import add from '../../../../../../assets/images/icons/add.svg'
import { maxFormPointsCount } from '../../../../../utils/constants'
import { usePointItem } from './hooks/usePointItem'
import React, {  SetStateAction } from 'react'
import { GMapInput } from '../gMapInput/GMapInput'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../../store/slices/settingsSlice'

type Props = {
  data: PointItemInterface[]
  el: PointItemInterface
  index: number
  isRoute: boolean
  addresses: boolean
  intercity: boolean
  topData: CargoItemInterface
  setData: React.Dispatch<SetStateAction<PointItemInterface[]>>
  addPoint: (pointItem: PointItemInterface) => void
  removePoint: (pointItem: PointItemInterface) => void
  pointUp: (pointItem: PointItemInterface) => void
  pointDown: (pointItem: PointItemInterface) => void
  dragStartHandler: (e: React.DragEvent<HTMLDivElement>, pointItem: PointItemInterface) => void
  dragLeaveHandler: (e: React.DragEvent<HTMLDivElement>) => void
  dragEndHandler: (e: React.DragEvent<HTMLDivElement>) => void
  dragOverHandler: (e: React.DragEvent<HTMLDivElement>) => void
  dropHandler: (e: React.DragEvent<HTMLDivElement>, pointItem: PointItemInterface) => void
  handleFormBlur: (index: number, event: React.ChangeEvent<HTMLInputElement>) => void
  setTopData: React.Dispatch<SetStateAction<CargoItemInterface>>
}

export const PointItem = ({
  isRoute,
  data,
  setData,
  el,
  index,
  addresses,
  intercity,
  addPoint,
  removePoint,
  pointUp,
  pointDown,
  dragStartHandler,
  dragLeaveHandler,
  dragEndHandler,
  dragOverHandler,
  dropHandler,
  handleFormBlur,
  topData,
  setTopData,
}: Props) => {
  usePointItem(setData, data, el, index)
  const location = useLocation()
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div
      className={classes.Container}
      onDragStart={(e) => dragStartHandler(e, el)}
      onDragLeave={(e) => dragLeaveHandler(e)}
      onDragEnd={(e) => dragEndHandler(e)}
      onDragOver={(e) => dragOverHandler(e)}
      onDrop={(e) => dropHandler(e, el)}
      draggable={true}
      key={index}
    >
      <GMapInput
        fieldName={
          (((addresses && intercity) || !intercity) && isRoute) ||
          location.pathname.split('/')[1] === 'slot'
            ? 'address'
            : 'city'
        }
        placeHolder={
          (((addresses && intercity) || !intercity) && isRoute) ||
          location.pathname.split('/')[1] === 'slot'
            ? 'Введите адрес'
            : 'Введите город'
        }
        setData={setData}
        el={el}
        index={index}
        data={data}
        addresses={addresses}
        intercity={intercity}
        topData={topData}
        setTopData={setTopData}
      />
      {isRoute && (
        <div className={classes.ButtonsAnchor}>
          <div className={classes.Buttons}>
            {el.sequence !== 1 && (
              <div className={darkTheme ? classes.IconContainerDark : classes.IconContainer}>
                <img
                  alt="Наверх"
                  className={classes.Icon}
                  src={arrow_left}
                  onClick={() => {
                    pointUp(el)
                  }}
                />
              </div>
            )}

            {el.sequence !== data.length && (
              <div className={darkTheme ? classes.IconContainerDark : classes.IconContainer}>
                <img
                  alt="Вниз"
                  className={classes.Icon}
                  src={arrow_right}
                  onClick={() => {
                    pointDown(el)
                  }}
                />
              </div>
            )}

            {data.length < maxFormPointsCount && (
              <div className={darkTheme ? classes.IconContainerDark : classes.IconContainer}>
                <img
                  alt="Добавить"
                  className={classes.Icon}
                  src={add}
                  onClick={() => {
                    addPoint(el)
                  }}
                />
              </div>
            )}

            {(isRoute && data.length === 2) || (!isRoute && data.length === 1) ? (
              <></>
            ) : (
              <div className={darkTheme ? classes.IconContainerDark : classes.IconContainer}>
                <img
                  alt="Удалить"
                  className={classes.Icon}
                  src={close}
                  onClick={() => {
                    removePoint(el)
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
